var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.displayLoggerAttributes && _vm.displayLoggerAttributes.length)?_c('ProductLoggerTable',{attrs:{"loggers":_vm.displayLoggerAttributes,"tableClass":"table-mobile"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }